module.exports = __webpack_public_path__ + "img/dynamic-31.e05b3cf5.png";